<template>
  <!-- 表头与操作共用勾选布局，各实例使用独立草稿，标题和保存逻辑由父页面区分。 -->
  <el-dialog :title="title || $t('message.customColumns')" :visible="visible" width="680px"
    custom-class="order-column-settings-dialog" :close-on-click-modal="false"
    @update:visible="$emit('update:visible', $event)">
    <!-- 只展示父页面提供的可用项，suffix 用于“删除（番）”等补充说明。 -->
    <el-checkbox-group v-model="selectedColumns" class="column-settings-list">
      <el-checkbox v-for="item in columns" :key="item.key" :label="item.key">
        {{ $t(item.labelKey) }}{{ item.suffix || '' }}
      </el-checkbox>
    </el-checkbox-group>
    <!-- 全部显示仅修改本次草稿；保存才将结果交回父页面持久化。 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="selectAll">{{ selectAllLabel || $t('message.showAllColumns') }}</el-button>
      <el-button @click="close">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('message.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // 弹窗显隐由父页面通过 visible.sync 控制。
    visible: Boolean,
    // 操作配置传入自定义标题；未传时保持原表头设置标题。
    title: { type: String, default: '' },
    // 可覆盖“全部显示”的文案，未传时沿用表头设置文案。
    selectAllLabel: { type: String, default: '' },
    // 当前状态可用的列或操作，每项包含 key、labelKey，可选 suffix。
    columns: {
      type: Array,
      default: () => [],
    },
    // 父页面已经生效的配置，仅用于打开时回显，不在弹窗内直接修改。
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedColumns: [], // 本次弹窗的勾选草稿，取消后不会写回父页面。
    }
  },
  watch: {
    // 每次打开都从已保存值重新生成草稿，并过滤当前不可用的项目。
    visible(value) {
      if (value) {
        const availableKeys = this.columns.map(item => item.key)
        this.selectedColumns = this.value.filter(key => availableKeys.includes(key))
      }
    },
  },
  methods: {
    // 选中当前弹窗内全部可用项，不包含其他状态或当前无权限的项目。
    selectAll() {
      this.selectedColumns = this.columns.map(item => item.key)
    },
    // 关闭时仅同步显隐；未保存的草稿在下次打开时重新初始化。
    close() {
      this.$emit('update:visible', false)
    },
    // 将草稿副本交给父页面，父页面分别保存表头或操作的浏览器配置。
    save() {
      this.$emit('save', [...this.selectedColumns])
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
// 表头和操作设置统一使用三列勾选布局。
.column-settings-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px 12px;

  /deep/.el-checkbox {
    margin-right: 0;
  }
}

// 保持弹窗内容左右留白，与原自定义表头的视觉样式一致。
/deep/.order-column-settings-dialog .el-dialog__body {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
